/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';

import AuthGuard from './components/AuthGuard';

import AuthLayout from './layouts/Auth';
import ErrorLayout from './layouts/Error';
import DashboardLayout from './layouts/Dashboard';
import DashboardAnalyticsView from './views/DashboardAnalytics';
import DashboardDefaultView from './views/DashboardDefault';
import OverviewView from './views/Overview';
import Home from './views/Home';
import PresentationView from './views/Presentation';
import Users from './views/Management/components/Users';
import Operators from './views/Management/components/Operators';
import OperatorDetails from './views/Management/components/OperatorDetails';
import Settings from './views/Management/components/Settings';
import DashboardInspect from './views/Dashboard/components/Inspect/DashboardInspect.js';
import ParameterPlanning from './views/ParameterPlanning/components/ParameterPlanning.js';
import CommissioningPlan from './views/Tracking/components/CommissioningPlan.js';
import CpichValidation from './views/Validation/components/CpichValidation.js';
import Tracker from './views/Tracking/components/Tracker.js';
import NbrRelationsValidation from './views/Validation/components/NbrRelationsValidation.js';
import RanShareNbrRelationsValidation from './views/Validation/components/RanShareNbrRelationsValidation.js';
import HealthChecks from './views/Validation/components/HealthChecks.js';
import WorkOrderStatus from './views/Tracking/components/WorkOrderStatus.js';
import NbrRelationsOptimization from './views/Optimization/components/NbrRelationsOptimization.js';
import UploadLogs from './views/Monitoring/components/UploadLogs.js';
import FaultManagement from './views/Monitoring/components/FaultManagement.js';
import ConfigurationManagement from './views/Monitoring/components/ConfigurationManagement.js';
import OverallSiteSummary from './views/Monitoring/components/OverallSiteSummary.js';
import SiteReport from './views/Monitoring/components/SiteReport.js';
import ANRValidation from './views/Validation/components/ANRValidation.js';
import CositeHealthCheck from './views/Validation/components/CositeHealthCheck.js';
import AnrNbrTracking from './views/Validation/components/AnrNbrTracking.js';
import E2ENbrRelations from './views/Optimization/components/E2ENbrRelations.js';

const routes = [
	{
		path: '/',
		exact: true,
		component: () => <Redirect to="/home" />,
	},
	{
		path: '/home',
		exact: true,
		component: () => AuthGuard({
			// roles: ['Administrator'],
			// operator: ['Vodafone', ...]
			// projects: ['Operations'],
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '*',
								exact: true,
								component: (props) => AuthGuard({
									// : ['Administrator', 'Manager'],
									children: Home(props)
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}

				}),
		}),
	},
	{
		path: '/planning',
		component: () => AuthGuard({
			roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
			projects: ['Operations'],
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/planning/parameterplanning',
								exact: true,
								component: () => AuthGuard({
									children: ParameterPlanning()
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}
				}
			)
		}),
	},
	{
		path: '/tracking',
		component: () => AuthGuard({
			roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
			projects: ['Operations'],
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/tracking/commissioningplan',
								exact: true,
								component: () => AuthGuard({
									children: CommissioningPlan()
								}),
							},
							{
								path: '/tracking/tracker',
								exact: true,
								component: () => AuthGuard({
									children: Tracker()
								}),
							},
							{
								path: '/tracking/workorderstatus',
								exact: true,
								component: () => AuthGuard({
									children: WorkOrderStatus()
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}
				}
			)
		}),
	},
	{
		path: '/validation',
		component: () => AuthGuard({
			roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
			projects: ['Operations'],
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/validation/anrvalidation',
								exact: true,
								component: () => AuthGuard({
									children: ANRValidation()
								}),
							},
							{
								path: '/validation/anrnbrtracking',
								exact: true,
								component: () => AuthGuard({
									children: AnrNbrTracking()
								}),
							},
							{
								path: '/validation/cositeHealthCheck',
								exact: true,
								component: () => AuthGuard({
									children: CositeHealthCheck()
								}),
							},
							{
								path: '/validation/cpichvalidation',
								exact: true,
								component: () => AuthGuard({
									children: CpichValidation()
								}),
							},
							{
								path: '/validation/nbrRelationsValidation',
								exact: true,
								component: () => AuthGuard({
									children: NbrRelationsValidation()
								}),
							},
							{
								path: '/validation/ranshareNbrRelationsValidation',
								exact: true,
								component: () => AuthGuard({
									children: RanShareNbrRelationsValidation()
								}),
							},
							{
								path: '/validation/healthChecks',
								exact: true,
								component: () => AuthGuard({
									children: HealthChecks()
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}
				}
			)
		}),
	},
	{
		path: '/optimization',
		component: () => AuthGuard({
			roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
			projects: ['Operations'],
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/optimization/nbrRelationsOptimization',
								exact: true,
								component: () => AuthGuard({
									children: NbrRelationsOptimization()
								}),
							},
							{
								path: '/optimization/e2eNbrRelations',
								exact: true,
								component: () => AuthGuard({
									children: E2ENbrRelations()
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}
				}
			)
		}),
	},
	{
		path: '/monitoring',
		component: () => AuthGuard({
			roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
			projects: ['Operations'],
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/monitoring/uploadLogs',
								exact: true,
								component: () => AuthGuard({
									children: UploadLogs()
								}),
							},
							{
								path: '/monitoring/faultManagement',
								exact: true,
								component: () => AuthGuard({
									children: FaultManagement()
								}),
							},
							{
								path: '/monitoring/configurationManagement',
								exact: true,
								component: () => AuthGuard({
									children: ConfigurationManagement()
								}),
							},
							{
								path: '/monitoring/overallSiteSummary',
								exact: true,
								component: () => AuthGuard({
									children: OverallSiteSummary()
								}),
							},
							{
								path: '/monitoring/siteReport',
								exact: true,
								component: () => AuthGuard({
									children: SiteReport()
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}
				}
			)
		}),
	},
	{
		path: '/dashboards',
		component: () => AuthGuard({
			// roles: ['Administrator'],
			// operator: ['Vodafone', ...]
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/dashboards/dashboardRollout',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									children: DashboardInspect({ match: { params: { id: 2 } }, pageTitle: 'Dashboard Rollout', module: 'Dashboards' })
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}

				}
			)
		}),
	},
	{
		path: '/NetworkPerformanceMonitoring',
		component: () => AuthGuard({
			// roles: ['Administrator'],
			// operator: ['Vodafone', ...]
			projects: ['Ran'],
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/NetworkPerformanceMonitoring/2gOverview',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									projects: ['Ran'],
									children: DashboardInspect({ match: { params: { id: 3 } }, pageTitle: '2G Performance', module: 'Dashboards' })
								}),
							},
							{
								path: '/NetworkPerformanceMonitoring/3gOverview',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									projects: ['Ran'],
									children: DashboardInspect({ match: { params: { id: 5 } }, pageTitle: '3G Performance', module: 'Dashboards' })
								}),
							},
							{
								path: '/NetworkPerformanceMonitoring/4gOverview',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									projects: ['Ran'],
									children: DashboardInspect({ match: { params: { id: 8 } }, pageTitle: '4G Performance', module: 'Dashboards' })
								}),
							},
							{
								path: '/NetworkPerformanceMonitoring/voLTEOverview',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									projects: ['Ran'],
									children: DashboardInspect({ match: { params: { id: 9 } }, pageTitle: 'voLTE Performance', module: 'Dashboards' })
								}),
							},
							{
								path: '/NetworkPerformanceMonitoring/5gOverview',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									projects: ['Ran'],
									children: DashboardInspect({ match: { params: { id: 10 } }, pageTitle: '5G Performance', module: 'Dashboards' })
								}),
							},
							{
								path: '/NetworkPerformanceMonitoring/Cluster/2G',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									projects: ['Ran'],
									children: DashboardInspect({ match: { params: { id: 11 } }, pageTitle: '2G Performance Clusters', module: 'Dashboards' })
								}),
							},
							{
								path: '/NetworkPerformanceMonitoring/Cluster/3G',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									projects: ['Ran'],
									children: DashboardInspect({ match: { params: { id: 12 } }, pageTitle: '3G Performance Clusters', module: 'Dashboards' })
								}),
							},
							{
								path: '/NetworkPerformanceMonitoring/Cluster/4G',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									projects: ['Ran'],
									children: DashboardInspect({ match: { params: { id: 13 } }, pageTitle: '4G Performance Clusters', module: 'Dashboards' })
								}),
							},
							{
								path: '/NetworkPerformanceMonitoring/Cluster/voLTE',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									projects: ['Ran'],
									children: DashboardInspect({ match: { params: { id: 15 } }, pageTitle: 'VoLTE Performance Clusters', module: 'Dashboards' })
								}),
							},
							{
								path: '/NetworkPerformanceMonitoring/Cluster/5G',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									projects: ['Ran'],
									children: DashboardInspect({ match: { params: { id: 14 } }, pageTitle: '5G Performance Clusters', module: 'Dashboards' })
								}),
							},
							{
								path: '/NetworkPerformanceMonitoring/Map',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									projects: ['Ran'],
									children: DashboardInspect({ match: { params: { id: 7 } }, pageTitle: 'PerformanceMap', module: 'Dashboards' })
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}

				}
			)
		}),
	},
	{
		path: '/activityTracker',
		component: () => AuthGuard({
			// roles: ['Administrator'],
			// operator: ['Vodafone', ...]
			projects: ['Ran'],
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/activityTracker/tracker',
								exact: true,
								component: () => AuthGuard({
									// roles: ['Administrator', 'Manager'],
									projects: ['Ran'],
									children: DashboardInspect({ match: { params: { id: 6 } }, pageTitle: 'Activity Tracker', module: 'Dashboards' })
								}),
							},
						],
					}
				}
			)
		}),
	},
	{
		path: '/management',
		component: () => AuthGuard({
			// roles: ['Administrator'],
			// operator: ['Vodafone', ...]
			children: DashboardLayout(
				{
					route: {
						routes: [
							{
								path: '/management/operators',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager'],
									children: Operators()
								}),
							},
							{
								path: '/management/operators/details',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager'],
									children: OperatorDetails()
								}),
							},
							{
								path: '/management/users',
								exact: true,
								component: () => AuthGuard({
									roles: ['Administrator', 'Manager'],
									children: Users(),
								}),
							},
							{
								path: '/management/settings',
								exact: true,
								component: () => AuthGuard({
									children: Settings()
								}),
							},
							{
								component: () => <Redirect to="/errors/error-404" />,
							},
						],
					}
				}
			)
		}),
	},
	{
		path: '/auth',
		component: AuthLayout,
		routes: [
			{
				path: '/auth/login',
				exact: true,
				component: lazy(() => import('views/Auth/Login')),
			},
			{
				path: '/auth/completeregistration',
				exact: true,
				component: lazy(() => import('views/Auth/CompleteRegistration')),
			},
			{
				path: '/auth/resetpassword',
				exact: true,
				component: lazy(() => import('views/Auth/ResetPassword')),
			},
			{
				path: '/auth/recover',
				exact: true,
				component: lazy(() => import('views/Auth/Recover')),
			},
			{
				path: '/auth/recoverconfirmation',
				exact: true,
				component: lazy(() => import('views/Auth/RecoverConfirmation')),
			},
			{
				component: () => <Redirect to="/errors/error-404" />,
			},
		],
	},

	{
		path: '/errors',
		component: ErrorLayout,
		routes: [
			{
				path: '/errors/error-401',
				exact: true,
				component: lazy(() => import('views/Error401')),
			},
			{
				path: '/errors/error-404',
				exact: true,
				component: lazy(() => import('views/Error404')),
			},
			{
				path: '/errors/error-500',
				exact: true,
				component: lazy(() => import('views/Error500')),
			},
			{
				component: () => <Redirect to="/errors/error-404" />,
			},
		],
	},
];

export default routes;
